export default "__VITE_ASSET__CoYuTsKT__"